import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AdminSettings from "./admin_settings";
import { openModal } from "../../../actions/modal_actions";
import { showToast } from "../../../actions/toast_actions";

const msp = (state, ownProps) => ({});

const mdp = (dispatch) => ({
  showToast: (message) => dispatch(showToast(message)),
});

export default withRouter(connect(msp, mdp)(AdminSettings));